import classnames from "classnames";

import Button from "@/components/button/Button.tsx";
import {PrivacyFooter} from "@/pages/billing/v2/summary/components/PrivacyFooter.tsx";

import styles from "./StickyFooter.module.scss";

export const StickyFooter = ({loading, formId}: {loading: boolean; formId: string}) => (
  <div
    className={classnames(styles.stickyFooter, "sticky-bottom d-none d-md-none p-4 pulse-bg-green-50")}
    id="bottomStickyFooter"
  >
    <Button
      disabled={loading}
      type="submit"
      className="w-100 text-uppercase"
      size="large"
      form={formId}
      variant="marketingPrimary"
    >
      {loading ? "Working..." : "Complete Checkout"}
    </Button>
    <PrivacyFooter />
  </div>
);
